import { Alert, Button, Checkbox, Modal, Space } from "antd"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useMemberId } from "pages/member"
import { useDeleteWaitingListSubscription } from "./queries"
import { IEvent } from "../types"

interface Props {
  open: (data?: IEvent) => void
  onClose: () => void
  isOpen: boolean
  data?: IEvent
}

const DeleteWaitingListSubscriptionModal: React.FC<Props> = ({
  data,
  ...props
}) => {
  const { t } = useTranslation("translation")
  const memberId = useMemberId()
  const [applySimilarEvent, setApplySimilarEvent] = useState<boolean>(
    data?.enrollment === "activity"
  )
  useEffect(() => {
    setApplySimilarEvent(data?.enrollment === "activity")
  }, [data?.enrollment])
  const onCheckBoxChange = () => {
    setApplySimilarEvent((old) => !old)
  }

  const { isLoading, mutate } = useDeleteWaitingListSubscription(memberId!, {
    meta: {
      type: "delete",
      context: "female",
      count: 1,
      entity: t("events.presubscription"),
    },
  })

  const onDelete = () => {
    mutate(
      {
        subscription_id: data?.waiting_list_id!,
        apply_to_similar_events: applySimilarEvent,
      },
      {
        onSettled() {
          props.onClose()
        },
      }
    )
  }
  return (
    <Modal
      centered
      width={1000}
      title={t("global.deleteX", {
        entity: t("events.subscription"),
        count: 0,
      })}
      open={props.isOpen}
      onCancel={props.onClose}
      footer={[
        <Button key="cancel" onClick={props.onClose} type="primary">
          {t("global.cancel")}
        </Button>,
        <Button
          onClick={onDelete}
          loading={isLoading}
          type="primary"
          key="delete"
          danger
        >
          {t("global.delete")}
        </Button>,
      ]}
      key={data?.waiting_list_id}
    >
      <Space direction="vertical">
        <Alert
          message={t("events.unsubscribe_member", {
            entity: data?.name,
          })}
          description={t(
            `events.${
              data?.enrollment === "activity"
                ? "delete_presubscription_activity"
                : "delete_presubscription_event"
            }`,
            {
              entity: data?.name,
            }
          )}
          type="info"
          showIcon
        />
        {data?.enrollment === "event" && (
          <Checkbox checked={applySimilarEvent} onChange={onCheckBoxChange}>
            {t("events.apply_all_activity_events")}
          </Checkbox>
        )}
      </Space>
    </Modal>
  )
}

export default DeleteWaitingListSubscriptionModal
